import { useUser } from "../context/UserContext";

const normalizeRole = (role?: string) =>
  role?.replace(/\s+/g, "").toLowerCase();

export const useRole = () => {
  const { user } = useUser();

  const role = normalizeRole(user?.user?.userRole);

  return {
    role,
    isSuperAdmin: role === "superadmin",
    isAdmin: role === "admin",
    isUser: role === "user",
  };
};